import React, { FC } from 'react'
import DownloadListItem, {
  IDownloadListItemData,
} from 'src/components/ui/download/DownloadListItem'
import FoldableListItem, {
  IFoldableListItemData,
} from 'src/components/ui/fold/FoldableListItem'
import FollowBulletListItem, {
  IFollowBulletListItemData,
} from 'src/components/ui/follow/FollowBulletListItem'
import TextItem, { ITextItemData } from 'src/components/ui/TextItem'
import Subtitle from 'src/components/ui/Subtitle'

type NavigableSectionItemData =
  | ITextItemData
  | IFoldableListItemData
  | IDownloadListItemData
  | IFollowBulletListItemData

export interface INavigableSectionProps {
  slug: string
  title: string
  items: { item: NavigableSectionItemData }[]
  className?: string
}

const NavigableSection: FC<INavigableSectionProps> = ({
  title,
  items,
  className,
}) => (
  <section data-name={title} id={title} className={`reveal-item opacity-0 bg-transparent ${className}`}>
    <Subtitle smallMargin>
      {title}
    </Subtitle>
    {items.map(({ item }) => {
      const key = `${item.type}${item.id}`
      switch (item.type) {
        case 'TextItem':
          return <TextItem key={key} content={item.content} noMargin />
        case 'FoldableListItem':
          return (
            <FoldableListItem
              key={key}
              elements={item.elements}
              showMoreLabel={item.showMoreLabel}
            />
          )
        case 'DownloadListItem':
          return <DownloadListItem key={key} elements={item.elements} />
        case 'FollowBulletListItem':
          return <FollowBulletListItem key={key} elements={item.elements} />
        default:
          throw new Error('Unknown type of navigable section item')
      }
    })}
  </section>
)

export default NavigableSection
